export function isValidFloatNumber(value: string): boolean {
  const reg = /^\d+([.,]\d+){0,1}$/;
  return reg.test(value);
}
